import {StyleSheet} from 'react-native';
import {random} from 'lodash';

import {indent} from '/constant/layout.constant';

export const styles = StyleSheet.create({
  footer: {
    marginVertical: indent,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  footerGroup: {
    minWidth: 140,
  },
  footerGroupTitle: {
    marginBottom: indent * 0.6,
  },
  footerRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  footerBoxPQV: {
    width: `${random(20, 35)}%`,
    height: 14,
  },
  footerBoxFQV: {
    width: `${random(20, 35)}%`,
    height: 14,
  },
  footerBoxGQV: {
    width: `${random(20, 35)}%`,
    height: 14,
  },
  footerBoxGEN0QV: {
    width: `${random(20, 35)}%`,
    height: 14,
  },
  footerBoxTGENV: {
    width: `${random(20, 35)}%`,
    height: 14,
  },
  footerBoxSC: {
    width: `${random(20, 35)}%`,
    height: 14,
  },
  footerBoxED: {
    width: `${random(20, 35)}%`,
    height: 14,
  },
  footerBoxFIBC: {
    width: `${random(20, 35)}%`,
    height: 14,
  },
  footerBoxFIBL: {
    width: `${random(20, 35)}%`,
    height: 14,
  },
});
